import { render } from "./Details.vue?vue&type=template&id=26f168d3&ts=true"
import script from "./Details.vue?vue&type=script&lang=ts&setup=true"
export * from "./Details.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/CropManagement/Details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26f168d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26f168d3', __exports__)) {
    console.log('reload')
    api.reload('26f168d3', __exports__)
  }
  
  module.hot.accept("./Details.vue?vue&type=template&id=26f168d3&ts=true", () => {
    console.log('re-render')
    api.rerender('26f168d3', render)
  })

}


export default __exports__